import { ReactElement, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCurrentPlatformHomeUrl } from '../../../../core/platform/hooks';
import { msalInstance } from '../../../../core/Auth/MsalInstance';

export default function Redirect(): ReactElement {
  const history = useHistory();
  const homeUrl = useCurrentPlatformHomeUrl();

  useEffect(() => {
    // Ensure MSAL has handled the hash and cached the account before navigating
    msalInstance
      .handleRedirectPromise()
      .catch(() => undefined)
      .finally(() => {
        const redirectRoute = window.sessionStorage.getItem('redirect_route');

        if (redirectRoute) {
          history.push(JSON.parse(redirectRoute));
        } else {
          history.push(homeUrl);
        }
      });
  }, [history, homeUrl]);

  return <></>;
}
